module.exports = __webpack_public_path__ + "static/up-arrow-5ca74f22cf790fa34ebefb1f3dbacf9b.svg";